//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { IReferenceType, IOpChangeState, IJsonSerializable } from '../util/interfaces'
import { Enums } from '../common/enums'
import { OpDataType } from './op-data-type'
import { OpDescr } from './op-descr'
import { DataProvider } from '../../helpers/data-provider'
import { Dictionary } from '../../helpers/dictionary'
import { CommonHelper } from '../../helpers/common-helper'

export class OpDataTypeInGroup implements IReferenceType, IOpChangeState, IJsonSerializable {
    //Properties
    public idDataTypeGroup: number
    public idDataType: number
    public orderNBR: number
    public name: string
    public idDescr: number
    public descr: OpDescr
    //Properties end
    //NavigationProperties
    public dataType: OpDataType
    //NavigationProperties end

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    //IOpChangeState implementation
    public opState: Enums.OpChangeState
    //IOpChangeState implementation end
    //IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdDataTypeGroup
    }
    public getReferenceKey(): number {
        return CommonHelper.getHashCode(this.idDataTypeGroup.toString() + "_" + this.idDataType.toString())
    }
    public getReferenceValue(): any {
        return this
    }
    //IReferenceType implementation end

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpDataTypeInGroup[]): JQueryPromise<OpDataTypeInGroup[]> {
        const defered = $.Deferred<OpDataTypeInGroup[]>()
        
        if (dataProvider && list && list.length > 0) {
            dataProvider.System.getDictionaries([Enums.ReferenceType.IdDataType]).then(dict => {
                var dataTypeDict: Dictionary<OpDataType> = new Dictionary<OpDataType>(null)
                if (dict.containsKey(Enums.ReferenceType.IdDataType)) {
                    dataTypeDict = <Dictionary<OpDataType>>dict.tryGetValue(Enums.ReferenceType.IdDataType)
                }

                list.forEach(item => {
                    item.dataType = dataTypeDict.tryGetValue(item.idDataType)
                })

                defered.resolve(list)
            })
        } else {
            defered.resolve(list)
        }

        return defered.promise()
    }

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {

            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {

                this.idDataTypeGroup = opObj.I
                this.idDataType = opObj.ID
                this.orderNBR = opObj.O
                this.idDescr = opObj.IDD
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.OP

            } else {

                this.idDataTypeGroup = opObj.ID_DATA_TYPE_GROUP
                this.idDataType = opObj.ID_DATA_TYPE
                this.orderNBR = opObj.ORDER_NBR
                this.idDescr = opObj.ID_DESCR
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState

            }
        }
    }

    public toJSON(compressed: boolean = false): any {

        if (compressed) {
            return {

                I: this.idDataTypeGroup,
                ID: this.idDataType,
                O: this.orderNBR,
                IDD: this.idDescr,
                D: this.descr != null ? this.descr.toJSON(compressed) : null,
                OP: this.opState,

                __IC: 1

            }
        } else {
            return {
                ID_DATA_TYPE_GROUP: this.idDataTypeGroup,
                ID_DATA_TYPE: this.idDataType,
                ORDER_NBR: this.orderNBR,
                ID_DESCR: this.idDescr,
                _Descr: this.descr != null ? this.descr.toJSON() : null,
                OpState: this.opState
            }
        }
    }

    public toString() {
        if (this.descr)
            return this.descr.toString()
        if (this.dataType)
            return this.dataType.toString()
        return "DataTypeInGroup [" + this.idDataTypeGroup + "]"
    }
}